import React from 'react';
import {useNavigate} from 'react-router-dom';

import styles from './styles.module.scss';

export default function knewMagagineBanner() {
  const navigator = useNavigate();

  return (
    <div className={styles.wrapper}>
      <div
        className={styles.banner}
        onClick={() => {
          navigator('/zip');
        }}>
        <div className={styles.bannerTitle}>MAGAZINE</div>
        <div className={styles.bannerDesc}>
          맛과 멋이 있는 큐레이션, 뉴뉴 매거진
        </div>
      </div>
      <span className={`arrow-right-white-icon ${styles.icon}`} />
    </div>
  );
}
